import TripTravellerAllocationRecommendationModule from './trip-traveller-allocation-recommendation/trip-traveller-allocation-recommendation-module';
import TripTravellerAllocationSegmentModule from './trip-traveller-allocation-segment/trip-traveller-allocation-segment-module';

import TripTravellerAllocation from './trip-traveller-allocation-component';
import TripTravellerAllocationService from './trip-traveller-allocation-service';

import './trip-traveller-allocation.scss';

const MODULE_NAME = 'app.trip.traveller-allocation';
const module = angular.module(MODULE_NAME, [
        TripTravellerAllocationRecommendationModule,
        TripTravellerAllocationSegmentModule,
    ])
    .directive(TripTravellerAllocation.DIRECTIVE_NAME, TripTravellerAllocation)
    .service('tripTravellerAllocationService', TripTravellerAllocationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-module.js